export enum EBannerType {
  RealtorRequestTrap,
  RentKpnCallback,
  RentNBListing,
}
